import {defineStore} from "pinia";
import type {FusionSharedDtosDirectUserDirectUserProfileResponseDto} from "~/types/api/api";

export const useUserStore = defineStore("UserStore", () => {

    const {$api} = useNuxtApp();
    const userProfile = ref<FusionSharedDtosDirectUserDirectUserProfileResponseDto>();

    const getUserProfile = async () => {
        const response = await $api.api.directUserProfileList()
        userProfile.value = response.data;
    }

    return {
        userProfile,
        getUserProfile,
    };
});
